<template>
  <div class="flex items-center h-full py-1">
    <div class="flex-1 min-w-0">
      <div class="sensitive font-medium text-gray-900 truncate">{{ titleCase(patientName) }}</div>
      <div class="sensitive text-xs text-blue-600 font-mono">{{ params.data?.patient_identifier }}</div>
      <div v-if="formattedDob" class="sensitive text-xs text-gray-500">{{ formattedDob }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quality_PatientCell',
  props: ['params'],
  computed: {
    formattedDob() {
      const dob = this.params.data?.bene_dob;
      if (!dob) return null;
      // Extract date-only portion to avoid UTC→local timezone shift (off-by-one day bug)
      const dateOnly = String(dob).substring(0, 10);
      const parts = dateOnly.split('-');
      if (parts.length !== 3) return dob;
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    },
    patientName() {
      const data = this.params.data || {};
      if (data.patient_name && data.patient_name !== 'Unknown') {
        return data.patient_name;
      }
      const first = data.bene_first_name || '';
      const last = data.bene_last_name || '';
      if (last || first) {
        return `${last}, ${first}`.replace(/^, |, $/g, '');
      }
      return 'Unknown';
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      const keep = new Set(['II', 'III', 'IV', 'JR', 'SR', 'MD', 'DO', 'NP', 'PA', 'RN']);
      return str.split(/\s+/).map(w => {
        const clean = w.replace(/[,.]$/, '');
        if (keep.has(clean.toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
